import { ArrowRight } from 'lucide-react'
import type { ReactNode } from 'react'
import { useTranslation } from 'react-i18next'
import { LocalizedLink } from '@/components/LocalizedLink'

interface ServiceCardProps {
  icon: ReactNode
  title: string
  description: string
  href?: string
}

export function ServiceCard({ icon, title, description, href = 'services' }: ServiceCardProps) {
  const { t } = useTranslation()

  return (
    <LocalizedLink
      to={href}
      className="group relative flex flex-col h-full bg-surface rounded-xl p-6 md:p-8 border border-border shadow-sm hover:shadow-xl hover:-translate-y-1 transition-all duration-300"
    >
      <div className="absolute bottom-0 left-0 right-0 h-1 bg-brand rounded-b-xl transition-all duration-300 group-hover:h-1.5 group-hover:bg-brand-dark" aria-hidden="true" />
      <div className="mb-6 inline-flex items-center justify-center w-14 h-14 rounded-full border-2 border-brand/20 text-brand transition-colors duration-300 group-hover:border-brand group-hover:bg-brand/5">
        {icon}
      </div>
      <h3 className="font-display text-h3 text-heading mb-3">{title}</h3>
      <p className="text-text leading-relaxed mb-5 flex-grow">{description}</p>
      <span className="inline-flex items-center gap-1.5 text-sm font-semibold text-brand group-hover:text-brand-dark transition-colors">
        {t('buttons.learnMore')}
        <ArrowRight className="w-4 h-4 transition-transform duration-300 group-hover:translate-x-1" />
      </span>
    </LocalizedLink>
  )
}
